import React from 'react';
import {
  Form, Row, Col, Input, Select, Button,Icon
} from 'antd';
import InputMask from "react-input-mask";
const { Option } = Select;
class EAD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values, zip: values.zip, address_type: this.props.item.address_Type_Id, id: this.props.item.id }, (val) => { });
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      ismailingaddselect: false
    }
  }
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { item } = this.props;
    if (item && item.address_Type_Name.trim() === "Mailing Address") {
      this.setState({
        ismailingaddselect: true
      })
    }


    setTimeout(() => {
      setFieldsValue({
        street: item.street, street1: item.street1, state: item.stateId, city: item.city, zip: item.zipCode, isprimaryAcc: item.isprimaryAcc, country: 'United States'
      });
    }, 100);
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { states } = this.props;
    const { item } = this.props;
    return (<Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
     {/* <Card> */}

      <div>

        <Row>
          <Col md={8} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Address 1</legend>
                {getFieldDecorator('street', {
                  rules: [{ required: true, message: 'Please enter street details' }, {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
                    message: "It allows only Alphanumerics _,/,#,-"
                  }],
                })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Address 1 *"/>)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Address 2</legend>
                {getFieldDecorator('street1', {
                  rules: [{ required: false, message: 'Please enter street details' }, {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
                    message: "It allows only Alphanumerics _,/,#,-"
                  }],
                })(<Input autoComplete={"nope"}  className="mi_input" type="text"  placeholder="Enter Address 2" />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">City</legend>

                {getFieldDecorator('city', {
                  rules: [{ required: true, message: 'Please enter city.' }, {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                    message: "It allows only Alphabets"
                  }],
                })(<Input autoComplete={"nope"}  maxLength={40} className="mi_input" type="text"  placeholder="Enter City *" />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item>
              <fieldset>
                <legend className="legend-font">State</legend>
                {getFieldDecorator('state', {
                  rules: [{ required: true, message: 'Please select state' }],
                })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                  showSearch={true}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  } className="mi_input"
                  onChange={this.onChange}
                  placeholder="Please Select State *" style={{marginLeft:'-9px'}}>
                  {states.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                </Select>)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Mailing Address Country</legend>
                {getFieldDecorator('country', {
                  rules: [{ required: false, message: 'Please enter street details.' }],
                })(<Input disabled autoComplete={"nope"}  maxLength={255} className="mi_input" type="text"  placeholder="Enter Mailing Address Country"/>)}
              </fieldset>
            </Form.Item>
          </Col>

          <Col md={8} sm={24}>
            <Form.Item>
              <fieldset>
                <legend className="legend-font">ZIP</legend>
                {getFieldDecorator('zip', {
                  rules: [{ required: true, message: 'Please enter a valid zip code' }
                    , {
                     pattern: /^\d{5}(?:[-\s]\d{4})?$/,
                    message: 'Zip code is invalid'
                  }],
                })(<InputMask mask="99999" autoComplete={"nope"}  className="ant-input mi_input" type="text"  placeholder="Enter ZIP *"/>)}
              </fieldset>
            </Form.Item>
          </Col>
          {this.state.ismailingaddselect ?
            <Col md={8} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font"> Default Address</legend>
                  {getFieldDecorator('isprimaryAcc', {
                    initialValue: false,
                    rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select a Default Address or Not. </span> }],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input" placeholder="Please Select Is Default Addres *" style={{marginLeft:'-11px'}} defaultValue={false}>
                    <Option value={true} key={true}>Yes</Option>
                    <Option value={false} key={false}>No</Option>
                  </Select>)}
                </fieldset>
              </Form.Item>
            </Col>
            : ""}
        </Row>
        <Row style={{marginRight:"20px"}}>
          <Button className="mi_button_right" type="primary" htmlType="submit">
            Update
          </Button>{" "}
          <Button className="mi_button_right submit-button"

            onClick={() => { this.props.removeAdderss(item.id) }}
          >
            Remove
          </Button>
        </Row>
      </div>
    </Form>)
  }
}
const EditAddress = Form.create()(EAD);
export default EditAddress;